<template lang="pug">
  b-modal#upsertLabel(
  ref="upsertLabel"
  :title="$t('ui.combine.edit_label')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div.d-flex.flex-row.mb-1
        div.p-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.fa.fa-user
            b-input(v-model="memberId" disabled)
      dragAndDrop(slot="customizeDragAndDrop" ref="draganddrop")
        div.d-flex.flex-row
          div(
            style="height: 270px;"
            @dragover.prevent
            @drop="dragFinishLabel($event, 'freeLabel', 'labelGroup')"
          ).p-1.d-flex.flex-column
            div.font-weight-bold.p-1.text-uppercase {{ $t('ui.available_label') }}
            div.flex-fill.clusterize-scroll
              table.tablex
                thead
                  tr
                    th(width=34)
                      span
                        input(type="checkbox" @click="rowSelect('all', 'freeLabel')" v-model="freeLabelAllSelected").checkbox
                    th
                      span {{ $t('ui.id') }}
                    th
                      span {{ $t('ui.name') }}
                tbody
                  tr(
                    v-for="(freeLabelInfo, index) in filterFreeLabelList"
                    @click="rowSelect(freeLabelInfo, 'freeLabel')"
                    :class="{ 'selectedRow' : selectedRow(freeLabelInfo, 'freeLabel') }"
                    draggable="true"
                    @dragstart="dragStartLabel($event, 'freeLabel', 'labelGroup')"
                    @dragend="dragEndLabel()"
                    )
                    td
                      span
                        input(type="checkbox" v-model="freeLabelIdSelected" :value="freeLabelInfo.label_id").checkbox
                    td
                      span {{ freeLabelInfo.label_id }}
                    td
                      span {{ freeLabelInfo.label_name }}
          div(
            style="height: 270px;"
            @dragover.prevent
            @drop="dragFinishLabel($event, 'memberLabel', 'labelGroup')"
          ).p-1.d-flex.flex-column
            div.font-weight-bold.p-1.text-uppercase {{ $t('ui.member_label') }}
            div.flex-fill.clusterize-scroll
              table.tablex
                thead
                  tr
                    th(width=34)
                      span
                        input(type="checkbox" @click="rowSelect('all', 'memberLabel')" v-model="memberLabelAllSelected").checkbox
                    th
                      span {{ $t('ui.id') }}
                    th
                      span {{ $t('ui.name') }}
                tbody
                  tr(
                    v-for="(memberLabelInfo, index) in filterMemberLabelList"
                    @click="rowSelect(memberLabelInfo, 'memberLabel')"
                    :class="{ 'selectedRow' : selectedRow(memberLabelInfo, 'memberLabel') }"
                    draggable="true"
                    @dragstart="dragStartLabel($event, 'memberLabel', 'labelGroup')"
                    @dragend="dragEndLabel()"
                    )
                    td
                      span
                        input(type="checkbox" v-model="memberLabelIdSelected" :value="memberLabelInfo.label_id").checkbox
                    td
                      span {{ memberLabelInfo.label_id }}
                    td
                      span {{ memberLabelInfo.label_name }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import dragAndDrop from "@/library/DragAndDrop";
import _ from "lodash";
import { setTimeout } from 'timers';

export default {
  components: {
    SubmitButton,
    dragAndDrop
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      dragging: -1,
      dragFromPos: "",
      freeLabelList: [],
      freeLabelIdSelected: [],
      freeLabelAllSelected: false,

      memberLabelList: [],
      memberLabelIdSelected: [],
      memberLabelAllSelected: false,

      memberId: "",
    }
  },
  computed: {
    isDragging() {
      return this.dragging > -1
    },
    filterFreeLabelList() {
      // var freeList = this.freeLabelList;
      // var groupList = this.memberLabelList;
      // var list = [];

      // for(var i = 0; i < freeList.length; i++) {
      //   var temp = groupList.filter(item => {
      //     return item.label_id == freeList[i]['label_id'];
      //   })

      //   if (temp.length == 0) {
      //     list.push(freeList[i]);
      //   }
      // }
      var list = this.freeLabelList;

      return list;
    },
    filterMemberLabelList() {
      var list = this.memberLabelList;

      return list;
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      let url = config.memberLabelUpsertUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.memberId,
        audit_by: this.$store.getters.loginId
      };

      var arr = [];
      for(var i = 0; i < this.memberLabelList.length; i++) {
        arr.push(this.memberLabelList[i].label_id);
      }

      json.label_id = arr.toString();

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.upsertLabel.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.memberId = this.item.account_id;
      this.memberLabelList = [];
      this.freeLabelList = [];
      this.getFreeLabelList();
      this.getMemberLabelList();
    },
    dragStartLabel: function(ev, fromPos, labelInfo) {
      this.dragFromPos = fromPos;

      if(this.dragFromPos== "freeLabel")
        this.dragging = this.freeLabelIdSelected;

      else if(this.dragFromPos == "memberLabel")
        this.dragging = this.memberLabelIdSelected;

      this.$refs.draganddrop.dragStart(ev, this.dragFromPos, labelInfo, this.dragging);
    },
    dragEndLabel: function(ev) {
      var dragDone = this.$refs.draganddrop.dragEnd(ev);

      if(!dragDone)
        return;

      if(this.dragFromPos == "freeLabel") {
        this.freeLabelIdSelected = [];
        this.freeLabelAllSelected = false;
      }

      else if(this.dragFromPos == "memberLabel") {
        this.memberLabelIdSelected = [];
        this.memberLabelAllSelected = false;
      }

      this.dragging = -1;
      this.dragFromPos = "";
    },
    dragFinishLabel: function(ev, dragFinPos, labelInfo) {
      if(this.dragFromPos == dragFinPos)
        return;

      if(this.dragFromPos == "freeLabel")
        this.$refs.draganddrop.dragFinish(ev, dragFinPos, this.freeLabelList, this.memberLabelList, labelInfo, 'label_id');

      else if(this.dragFromPos == "memberLabel")
        this.$refs.draganddrop.dragFinish(ev, dragFinPos, this.memberLabelList, this.freeLabelList, labelInfo, 'label_id');
    },
    selectedRow: function(info, type) {
      if(type == "freeLabel") {
        for(var i = 0; i < this.freeLabelIdSelected.length; i++) {
          if(this.freeLabelIdSelected[i] == info.label_id)
            return true;
        }
      }

      else if(type == 'memberLabel') {
        for(var i = 0; i < this.memberLabelIdSelected.length; i++) {
          if(this.memberLabelIdSelected[i] == info.label_id)
            return true;
        }
      }

      return false;
    },
    rowSelect: function(labelInfo, type) {
      if(type == 'freeLabel') {
        if(labelInfo != "all") {
          var index = this.freeLabelIdSelected.indexOf(labelInfo.label_id);

          if(index == -1)
            this.freeLabelIdSelected.push(labelInfo.label_id);

          else
            this.freeLabelIdSelected.splice(index, 1);
        }
        else {
            setTimeout(() => {
              if(this.freeLabelAllSelected) {
                for(var i = 0; i < this.freeLabelList.length; i++) {
                  var index = this.freeLabelIdSelected.indexOf(this.freeLabelList[i].label_id);

                  if(index == -1)
                    this.freeLabelIdSelected.push(this.freeLabelList[i].label_id);
                }
            }
            else {
              this.freeLabelIdSelected = [];
            }
          }, 10);
        }
      }

      else if(type == 'memberLabel') {
        if(labelInfo != "all") {
          var index = this.memberLabelIdSelected.indexOf(labelInfo.label_id);

          if(index == -1)
            this.memberLabelIdSelected.push(labelInfo.label_id);

          else
            this.memberLabelIdSelected.splice(index, 1);
        }

        else {
          setTimeout(() => {
            if(this.memberLabelAllSelected) {
              for(var i = 0; i < this.memberLabelList.length; i++) {
                var index = this.memberLabelIdSelected.indexOf(this.memberLabelList[i].label_id);

                if(index == -1)
                  this.memberLabelIdSelected.push(this.memberLabelList[i].label_id);
              }
            }

            else {
              this.memberLabelIdSelected = [];
            }
          })
        }
      }
    },
    getFreeLabelList: function () {
      let url = config.memberLabelGetAvailableUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.memberId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.freeLabelList = response.data.dt;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMemberLabelList: function () {
      let url = config.memberLabelGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.memberId
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.memberLabelList = response.data.dt;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    }
  },
}
</script>
<style lang="scss" scoped>
</style>
